import liveCheckReducerMap from 'wanderu-ducks-live-check';
import psearchReducerMap from 'wanderu-ducks-psearch';
import searchReducerMap from 'wanderu-ducks-search';

import TripSummary from '../containers/TripSummary/TripSummary';

function onLoad(module, info, props, context) {
    context.store.inject({
        ...searchReducerMap,
        ...psearchReducerMap,
        ...liveCheckReducerMap,
    });
}

export { onLoad };
export default TripSummary;
